// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type CareerHubGlossaryQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CareerHubGlossaryQuery = {
  __typename?: 'Query';
  careerHubGlossary?: {
    __typename?: 'CareerHubGlossaryResponse';
    collection: Array<{
      __typename?: 'CareerHubGlossaryCollection';
      letter?: string | null;
      articles: Array<{
        __typename?: 'CareerHubGlossaryArticle';
        url: string;
        title: string;
      } | null>;
    } | null>;
  } | null;
};

export const CareerHubGlossaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'careerHubGlossary' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'careerHubGlossary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'CareerHubGlossaryCollection',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareerHubGlossaryArticle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareerHubGlossaryArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CareerHubGlossaryCollection' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CareerHubGlossaryCollection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'letter' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CareerHubGlossaryArticle' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CareerHubGlossaryQuery,
  CareerHubGlossaryQueryVariables
>;
